<template>
	<div class="container-fluid">
		<div class="border-top pt-2"></div>
		<div class="row d-flex justify-content-center p-2">
			<div class="col-12 h3 font-weight-bold">
				
			</div>
			<div
				class="col-12 col-md-4"
				v-for="(v,k) in productListTypes"
				:key="k"
				v-if="k > 0"
			>
				<p class="h3 font-weight-bold">
					{{ v.text }}:
				</p>
				<div
					v-for="(item,index) in products"
					:key="`pr-${index}`"
					v-if="item.listType == k"
				>
					<orderitem
						:smallClass="true"
						:tszam="item.tszam"
						:nev="item.nev"
						:ar="item.ar"
						:db="item.db"
					/>
				</div>
			</div>
			<!--<div
				class="col-12"
				v-for="(item_pr,index) in products"
				:key="`pr-${index}`"
			>
				<orderitem
					:tszam="item_pr.tszam"
					:nev="item_pr.nev"
					:ar="item_pr.ar"
					:db="item_pr.db"
				/>
			</div>-->
		</div>
	</div>
</template>
<script type="text/javascript">
import orderitem from './order_item'
export default {
	components: {
		orderitem
	},

	data() {
		return {
			products: []
		}
	},

	mounted(){
		this.$Progress.start()
		this.req.get('products/search/highlighted')
			.then(res => {
				this.products = res.data.list
				this.$Progress.finish()
			})
			.catch(err => {
				console.log(err)
				this.$Progress.fail()
			})
	}
}
</script>


// WEBPACK FOOTER //
// src/components/orders/highlightedProducts.vue